import React from 'react';
import { RiskFactorField } from './RiskFactorField';
import type { RiskFactorConfig } from '../constants/riskFactorConfig';
import type { CapriniRiskAssessmentData } from '../models';
import { McParameterDetailResponseDto } from 'src/api/references/referenceServicesDtos';

interface RiskFactorListProps {
  configs: RiskFactorConfig[];
  cardData: {
    mcpConfig: Record<keyof CapriniRiskAssessmentData, { mcpId: number } | undefined>;
  };
  selectedMCPs: Record<keyof CapriniRiskAssessmentData, McParameterDetailResponseDto | McParameterDetailResponseDto[] | null>;
  handleMCPChange: (field: keyof CapriniRiskAssessmentData, value: McParameterDetailResponseDto) => void;
  getMCPParameterDetails: (mcpId: number) => McParameterDetailResponseDto[];
  mcpCacheLoaded: boolean;
  extraAccess?: boolean;
}

export const RiskFactorList: React.FC<RiskFactorListProps> = ({
  configs,
  cardData,
  selectedMCPs,
  handleMCPChange,
  getMCPParameterDetails,
  mcpCacheLoaded,
  extraAccess,
}) => {
  const getMCPId = (fieldKey: keyof CapriniRiskAssessmentData): number => {
    return cardData.mcpConfig[fieldKey]?.mcpId || 0;
  };

  return (
    <>
      {configs.map((config) => {
        const mcpId = getMCPId(config.fieldKey);
        return (
          <RiskFactorField
            key={config.fieldKey}
            labelKey={config.labelKey}
            fieldKey={config.fieldKey}
            mcpId={mcpId}
            value={selectedMCPs[config.fieldKey] || null}
            onMCPChange={handleMCPChange}
            cachedData={getMCPParameterDetails(mcpId)}
            cacheLoaded={mcpCacheLoaded}
            extraAccess={extraAccess}
            fieldType={config.fieldType}
          />
        );
      })}
    </>
  );
};

